// src/pages/Admin/Package.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function Package() {
  const [packages, setPackages] = useState([]);
  const [newPackage, setNewPackage] = useState({
    name: "",
    price: "",
    dailyAds: "",
    validity: "",
    referLevel: "",
  });
  const [editPackage, setEditPackage] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      // 🔹 Backend API: GET /admin/packages
      const token = localStorage.getItem("token"); // Optional: if protected
      const res = await axios.get("https://api.earnmoney0.top/admin/packages", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (res.data.success) setPackages(res.data.packages);
    } catch (err) {
      console.error("❌ Fetch Packages Error:", err);
    }
  };

  const handleAddPackage = async () => {
    if (!newPackage.name || !newPackage.price)
      return alert("Please fill required fields");
    try {
      // 🔹 Backend API: POST /admin/packages
      const token = localStorage.getItem("token"); // Optional
      const res = await axios.post(
        "https://api.earnmoney0.top/admin/packages",
        newPackage,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      if (res.data.success) {
        alert("✅ Package added successfully!");
        setNewPackage({
          name: "",
          price: "",
          dailyAds: "",
          validity: "",
          referLevel: "",
        });
        fetchPackages();
      }
    } catch (err) {
      console.error("Add Package Error:", err);
    }
  };

  const handleEditPackage = async () => {
  if (!editPackage) return;
  try {
    const token = localStorage.getItem("token"); // Optional
    // Numeric fields number হিসেবে পাঠাচ্ছি
    const payload = {
      ...editPackage,
      price: Number(editPackage.price),
      dailyAds: Number(editPackage.dailyAds),
      validity: Number(editPackage.validity),
      referLevel: Number(editPackage.referLevel),
    };

    const res = await axios.put(
      `https://api.earnmoney0.top/admin/packages/${editPackage._id}`,
      payload,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );

    if (res.data.success) {
      alert("✅ Package updated successfully!");
      setEditPackage(null);
      fetchPackages();
    }
  } catch (err) {
    console.error("Edit Package Error:", err);
    alert("❌ Failed to update package");
  }
};

  const handleInputChange = (e, type = "new") => {
    const { name, value } = e.target;
    if (type === "new")
      setNewPackage((prev) => ({ ...prev, [name]: value }));
    else if (type === "edit")
      setEditPackage((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="package-page">
      <style>{`
        .package-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }
        h2 {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 24px;
          color: #3b82f6;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          background: #111827;
          border-radius: 12px;
          overflow: hidden;
          margin-bottom: 24px;
        }
        th, td {
          padding: 12px;
          text-align: left;
          border-bottom: 1px solid #333;
        }
        th {
          color: #3b82f6;
          text-transform: uppercase;
        }
        tr:hover {
          background: #1f2937;
        }
        input {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #444;
          background: #111827;
          color: white;
          margin-right: 12px;
          margin-bottom: 12px;
          width: 150px;
        }
        button {
          padding: 8px 14px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
        }
        .add-btn {
          background: #22c55e;
          color: black;
        }
        .add-btn:hover {
          background: #16a34a;
        }
        .edit-btn {
          background: #3b82f6;
          color: black;
        }
        .edit-btn:hover {
          background: #2563eb;
        }
        @media (max-width: 640px) {
          h2 { font-size: 22px; }
          input { width: 100%; }
          table th, table td { padding: 8px; font-size: 14px; }
        }
      `}</style>

      <h2>📦 Package Management</h2>

      {/* Add New Package */}
      <div className="add-package">
        <input
          type="text"
          name="name"
          placeholder="Plan Name"
          value={newPackage.name}
          onChange={(e) => handleInputChange(e)}
        />
        <input
          type="number"
          name="price"
          placeholder="Price"
          value={newPackage.price}
          onChange={(e) => handleInputChange(e)}
        />
        <input
          type="text"
          name="dailyAds"
          placeholder="Daily Ads Limit"
          value={newPackage.dailyAds}
          onChange={(e) => handleInputChange(e)}
        />
        <input
          type="text"
          name="validity"
          placeholder="Validity"
          value={newPackage.validity}
          onChange={(e) => handleInputChange(e)}
        />
        <input
          type="text"
          name="referLevel"
          placeholder="Refer Level"
          value={newPackage.referLevel}
          onChange={(e) => handleInputChange(e)}
        />
        <button className="add-btn" onClick={handleAddPackage}>
          ➕ Add Package
        </button>
      </div>

      {/* Package List */}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Plan Name</th>
            <th>Price</th>
            <th>Daily Ads Limit</th>
            <th>Validity</th>
            <th>Refer Level</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {packages.length === 0 ? (
            <tr>
              <td
                colSpan="7"
                style={{ textAlign: "center", color: "#888", padding: "12px" }}
              >
                No packages found
              </td>
            </tr>
          ) : (
            packages.map((pkg, index) => (
              <tr key={pkg._id}>
                <td>{index + 1}</td>
                <td>
                  {editPackage && editPackage._id === pkg._id ? (
                    <input
                      name="name"
                      value={editPackage.name}
                      onChange={(e) => handleInputChange(e, "edit")}
                    />
                  ) : (
                    pkg.name
                  )}
                </td>
                <td>
                  {editPackage && editPackage._id === pkg._id ? (
                    <input
                      type="number"
                      name="price"
                      value={editPackage.price}
                      onChange={(e) => handleInputChange(e, "edit")}
                    />
                  ) : (
                    pkg.price
                  )}
                </td>
                <td>
                  {editPackage && editPackage._id === pkg._id ? (
                    <input
                      name="dailyAds"
                      value={editPackage.dailyAds}
                      onChange={(e) => handleInputChange(e, "edit")}
                    />
                  ) : (
                    pkg.dailyAds
                  )}
                </td>
                <td>
                  {editPackage && editPackage._id === pkg._id ? (
                    <input
                      name="validity"
                      value={editPackage.validity}
                      onChange={(e) => handleInputChange(e, "edit")}
                    />
                  ) : (
                    pkg.validity
                  )}
                </td>
                <td>
                  {editPackage && editPackage._id === pkg._id ? (
                    <input
                      name="referLevel"
                      value={editPackage.referLevel}
                      onChange={(e) => handleInputChange(e, "edit")}
                    />
                  ) : (
                    pkg.referLevel
                  )}
                </td>
                <td>
  {editPackage && editPackage._id === pkg._id ? (
    <>
      <button className="edit-btn" onClick={handleEditPackage}>
        💾 Save
      </button>
      <button
        className="edit-btn"
        style={{ background: "#ef4444", marginLeft: "6px" }}
        onClick={async () => {
          if (window.confirm("Are you sure to delete this package?")) {
            try {
              const token = localStorage.getItem("token");
              await axios.delete(
                `https://api.earnmoney0.top/admin/packages/${pkg._id}`,
                { headers: token ? { Authorization: `Bearer ${token}` } : {} }
              );
              fetchPackages();
            } catch (err) {
              console.error("Delete Package Error:", err);
              alert("❌ Failed to delete package");
            }
          }
        }}
      >
        🗑 Delete
      </button>
    </>
  ) : (
    <button
      className="edit-btn"
      onClick={() => setEditPackage(pkg)}
    >
      ✏️ Edit
    </button>
  )}
</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}